import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.5 2H2v3H1v1h1v4H1v1h1v4H1v1h1v3h13.5c1.378 0 2.5-1.122 2.5-2.5v-12C18 3.122 16.878 2 15.5 2zm0 1c.827 0 1.5.673 1.5 1.5v12c0 .827-.673 1.5-1.5 1.5H3v-2h1v-1H3v-4h1v-1H3V6h1V5H3V3h12.5z',
    'M13 13H7c0-1.657 1.58-2 3-2s3 .343 3 2zm-3-6c-.828 0-1.5.672-1.5 1.5S9.172 10 10 10s1.5-.672 1.5-1.5S10.828 7 10 7z',
  ],
  height: 20,
  width: 20,
});
